


















































































































































































































import Vue from "vue";
import IconButton from "@/components/IconButton.vue";
import NavigationButton from "@/components/NavigationButton.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateInput from "@/components/DateInput.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import PartnerHistory from "./historyViews/PartnerHistory.vue";
import InvoiceHistory from "./historyViews/InvoiceHistory.vue";
import InvoiceDetails from "./detailViews/InvoiceDetails.vue";
import SyncStatusBadge from "./SyncStatusBadge.vue";
import store, { InterfaceStore } from "../services/InterfaceStore";
import { IfaceType } from "../models/IfaceType";
import { Iface } from "../models/Iface";
import { partnerCodeAndName, payModeCodeAndName } from "../models/IfaceSyncInvoiceHeadDTO";
import globalStore, { GlobalStore } from "@/models/GlobalStore";
import configuration from "@/models/Configuration";
import { roundMoney } from "@/services/prices";

interface Data {
  store: InterfaceStore;
  globalStore: GlobalStore;
  IfaceType: typeof IfaceType;
}

interface Methods {
  onItemSelectedChange(value: boolean, item: any): void;
  setItemState(item: any, itemState: string): void;
  editPartner(id: number): void;
  saveItem(item: any): void;
  cancelEdit(item: any): void;
  toggleInvoiceItems(item: any): void;
  /** Igaz, ha az aktuálisan kiválasztott interfész típus megegyezik a megadottal. */
  ifaceTypeIs(ifaceType: IfaceType): boolean;
  /** A sor szerkesztő mezői aktívak-e (előzmény módban és kikapcsolt listás szerkesztésnél soha). */
  isItemInEdit(item: any): boolean;
  /** A részletes szerkesztő / nézegető route-ja az adott sor típusa alapján. */
  editUrlFor(item: any): string;
  /** A már beemelt belső számla route-ja, ha a szinkron sor kapott belső azonosítót. */
  internalInvoiceUrl(item: any): string;
  /** Partner megjelenítés a listában: "(partner kód) partner név". */
  partnerDisplay(item: any): string;
  /** Fizetési mód megjelenítés a listában: "(külső kód) K2D megnevezés". */
  payModeDisplay(item: any): string;
  /**
   * BillCity interfész — a nettó és az áfa nem az interfészről jön, hanem a tételekből számoljuk,
   * ezért a listán csak megjelenítjük. Más interfészen ezek az interfész adatai, tehát szerkeszthetők.
   */
  isBillCity(item: any): boolean;
  /** Fej szintű összeg tizedesjegyek az adott pénznemhez. */
  headDigits(currency: string | null): number;
  /** Számla pénznemében megadott összeg beírása — a HUF megfelelőt az árfolyammal frissítjük. */
  setCurrAmount(item: any, field: string, value: number): void;
}

interface Computed {
  /** Számla típus (bejövő vagy kimenő) van kiválasztva. */
  isInvoice: boolean;
  /** A listás (inline) szerkesztés engedélyezett-e ezen a felületen. */
  canInlineEdit: boolean;
  /** Az előzmény gomb látszik-e a soron. */
  isHistoryButtonVisible: boolean;
}

interface Props {
  url: string;
  columns: any[];
  name: string;
  refreshEvent: string;
  extraFilter: object;
  color: string;
  /** Előzmény mód — csak megtekintő gombok, nincs kijelölés és listás szerkesztés. */
  historyMode: boolean;
}

/**
 * A szinkron köztes tábla sorok listája (a főoldalon a hibás és a sikeres lista is ezt használja,
 * eltérő url / oszlopok / szűrő propokkal). Előzmény módban csak megtekintő funkciókat kínál.
 */
export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SyncEntityList",

  components: {
    ApiSearchPage,
    IconButton,
    NavigationButton,
    CheckBox,
    DateInput,
    DateTimeDisplay,
    MoneyInput,
    PartnerHistory,
    InvoiceHistory,
    InvoiceDetails,
    SyncStatusBadge,
  },

  props: {
    url: { type: String, required: true },
    columns: { type: Array, default: () => [] },
    name: { type: String, required: true },
    refreshEvent: { type: String, default: "" },
    extraFilter: { type: Object, default: () => ({}) },
    color: { type: String, default: "" },
    historyMode: { type: Boolean, default: false },
  },

  data() {
    return {
      store,
      globalStore,
      IfaceType,
    };
  },

  computed: {
    isInvoice(): boolean {
      return this.ifaceTypeIs(IfaceType.InInvoice) || this.ifaceTypeIs(IfaceType.OutInvoice);
    },

    canInlineEdit(): boolean {
      return !this.historyMode && configuration.sysParams.ifaceSyncIsFastEdit;
    },

    /**
     * Előzmény módban mindig van előzmény gomb (ez a felület fő funkciója), a főoldalon viszont
     * csak akkor, ha az előzmények nincsenek külön menüpontba választva.
     */
    isHistoryButtonVisible(): boolean {
      return this.historyMode || !configuration.sysParams.ifaceSyncIsSepHistory;
    },
  },

  methods: {
    ifaceTypeIs(ifaceType: IfaceType): boolean {
      return this.store.selectedInterfaceType === ifaceType;
    },

    isItemInEdit(item: any): boolean {
      return this.canInlineEdit && item.inEdit;
    },

    /**
     * A "nagyító" gomb route-ja az adott sor részletes szerkesztőjéhez — előzmény módban a
     * csak olvasható nézegető route-jára mutat. Car / Part típusnál még nincs szerkesztő.
     */
    editUrlFor(item: any): string {
      const base = this.historyMode ? "/interface/history" : "/interface";
      switch (this.store.selectedInterfaceType) {
        case IfaceType.Partner: return `${base}/partner/edit/${item.id}`;
        case IfaceType.InInvoice:
        case IfaceType.OutInvoice: return `${base}/invoice/edit/${item.id}`;
        default: return "";
      }
    },

    /**
     * A beemelt belső számla route-ja. Csak akkor ad vissza útvonalat, ha a szinkron sor már
     * kapott belső azonosítót — a felületen ettől függ, hogy a számlaszám link-e vagy sima szöveg.
     * Kimenő számláknál egyelőre nincs cél route, ezért ott mindig sima szöveg.
     */
    internalInvoiceUrl(item) {
      if (this.ifaceTypeIs(IfaceType.InInvoice) && item.geniId > 1) {
        return `/general-incoming-invoice/flow/edit/${item.geniId}/2`;
      }
      return "";
    },

    partnerDisplay(item) {
      return partnerCodeAndName(item);
    },

    payModeDisplay(item) {
      return payModeCodeAndName(item);
    },

    isBillCity(item) {
      return item.interface == Iface.BillCity;
    },

    headDigits(currency) {
      return configuration.getCurrDigits(currency ?? "HUF")?.geniHeadDigits ?? 0;
    },

    /**
     * A listán a számla pénznemében szerkesztünk, a köztes tábla viszont a HUF értéket is tárolja —
     * ezért az árfolyammal átszámolva a HUF párt is frissítjük. Árfolyam nélkül a HUF érték marad.
     */
    setCurrAmount(item, field, value) {
      item[field] = value;

      const hufFields: Record<string, string> = { currNetto: "netto", currVat: "vat", currTotal: "total" };
      const hufField = hufFields[field];
      const exchangeRate = Number(item.exchangeRate) || 0;
      if (!hufField || exchangeRate <= 0) return;

      item[hufField] = roundMoney((Number(value) || 0) * exchangeRate, "HUF", 2);
    },

    editPartner(id) {
      if (id <= 1) return;
      this.$router.push(`/partners/${id}`);
    },

    /** Multi-select checkbox független a setItemState-től (tömeges műveletekhez). */
    onItemSelectedChange(value, item) {
      item.selected = value;
    },

    /**
     * Soronkénti állapot-kapcsoló. InEdit és ShowDetails egymástól függetlenül kapcsolhatók —
     * egyszerre is lehetnek nyitva. A `selected` (multi-select) szintén független.
     */
    setItemState(item, itemState) {
      if (itemState === globalStore.itemState.InEdit) {
        // Edit módba lépéskor backup-oljuk a szerkeszthető mezőket a Cancel-hez
        if (!item.inEdit) {
          this.$set(item, "_backup", { ...item });
        }
        item.inEdit = !item.inEdit;
      } else if (itemState === globalStore.itemState.ShowDetails) {
        // History mód toggle. A `showHistory` és `showItems` mutual-exclusive — most history-t mutatunk.
        if (item.showDetails && item.showHistory) {
          item.showDetails = false;
          item.showHistory = false;
        } else {
          item.showDetails = true;
          this.$set(item, "showHistory", true);
          this.$set(item, "showItems", false);
        }
      }
    },

    /** Visszaállítja az edit-előtti értékeket és kilép edit módból. */
    cancelEdit(item) {
      if (item._backup) {
        Object.keys(item._backup).forEach((k) => {
          item[k] = item._backup[k];
        });
        item._backup = null;
      }
      item.inEdit = false;
    },

    /** Számlatétel lista lenyitása/csukása — showDetails + showItems. */
    toggleInvoiceItems(item) {
      if (item.showDetails && item.showItems) {
        item.showDetails = false;
        item.showItems = false;
      } else {
        item.showDetails = true;
        this.$set(item, "showItems", true);
        this.$set(item, "showHistory", false);
      }
    },

    /**
     * Listás szerkesztés lezárása. Külön mentő végpont nincs: a módosított sor a
     * userModified flaggel és kijelöléssel az újraszinkronizáláskor megy fel a backendre.
     */
    saveItem(item) {
      item._backup = null;
      item.inEdit = false;
      item.userModified = true;
      item.selected = true;
    },
  },
});
